import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';
import Modal from '../../../controls/Modal';
import LabeledInput from '../../../controls/LabeledInput';
import AppMediaList from '../../../controls/media/AppMediaList';

// Модалка точки легенды: название, код, вопрос, QR и медиа (изображения/аудио/видео).
export default function PointModal({ point, legendsState, qrBaseUrl, onClose, onDelete, onSave }) {
    const [form, setForm] = useState({ name: point.name || '', code: point.code || '', question: point.question || '' });
    const [media, setMedia] = useState(point.mediaList || point.mediaFiles || []);
    const [pending, setPending] = useState([]);

    const set = (field) => (e) => setForm(prev => ({ ...prev, [field]: e.target.value }));
    const qrValue = qrBaseUrl ? `${qrBaseUrl}${form.code}` : form.code;

    const handleDelete = async () => {
        onClose();
        try {
            await legendsState.deletePoint(point.id);
            onDelete(point.id);
        } catch (e) { /* ошибку покажет хук */ }
    };

    const handleSave = async () => {
        try {
            const existing = media.filter(it => !it.__pending);
            const resp = await legendsState.savePoint(point.id, { ...form, mediaList: existing }, pending);
            const updatedMedia = pending.length > 0 ? (resp?.mediaList || resp?.mediaFiles || []) : existing;
            setPending([]);
            onSave?.({ ...point, ...form, mediaList: updatedMedia });
            onClose();
        } catch (e) { /* ошибку покажет хук */ }
    };

    const footer = (
        <>
            <button type="button" className="btn btn-danger" style={{ marginRight: 'auto' }} onClick={handleDelete}>Удалить</button>
            <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
            <button type="button" className="btn btn-primary" onClick={handleSave}>Сохранить</button>
        </>
    );

    return (
        <Modal open kicker="Точка" title={point.name ? 'Редактировать точку' : 'Новая точка'} size="lg" onClose={onClose} footer={footer}>
            <div className="fr-grid2">
                <LabeledInput label="Название" value={form.name} onChange={set('name')} />
                <LabeledInput label="Код" value={form.code} onChange={set('code')} />
            </div>
            <div>
                <label className="ctl-label">Вопрос</label>
                <textarea className="textarea" value={form.question} onChange={set('question')} />
            </div>
            <div className="fr-qrbox">
                <div className="fr-qrbig">{form.code && <QRCodeSVG value={qrValue} size={110} level="M" />}</div>
                <div className="qrr">
                    <label className="ctl-label">QR точки</label>
                    <div className="fr-qrhint">QR ведёт на {qrValue}</div>
                </div>
            </div>
            <div>
                <div className="section-label">Медиа</div>
                <AppMediaList value={media} pendingFiles={pending} onChange={(v, p) => { setMedia(v); setPending(p); }} type="ALL" />
            </div>
        </Modal>
    );
}

PointModal.propTypes = {
    point: PropTypes.object.isRequired,
    legendsState: PropTypes.object.isRequired,
    qrBaseUrl: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onSave: PropTypes.func
};

PointModal.defaultProps = { qrBaseUrl: null, onSave: undefined };
